import type { Locales } from '@/locales/resources';

export interface UserSettings {
  language: Locales | 'auto';
  theme: 'light' | 'dark' | 'auto';
  color: string;
  phoneNumber?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  emailNotification?: boolean;
  subscription?: boolean;
}

export interface UserSettingsState {
  settings: UserSettings;
  isUpdatingSettings: boolean;
  settingsError?: string;
}

export const initialSettingsState: UserSettingsState = {
  settings: {
    language: 'auto',
    theme: 'auto',
    color: '#966c6c',
  },
  isUpdatingSettings: false,
  settingsError: undefined,
};
